import { Box, TableCell, Tooltip } from '@mui/material';
import { UserLabels } from "src/model/api/v2/data-contracts";
import { getContrastColor } from "src/utils/labelColors";
import { theme } from "src/theme/mui-theme";

interface ProjectListLabelsCellProps {
    labels: UserLabels[];
}

export const ProjectListLabelsCell = ({ labels }: ProjectListLabelsCellProps) => {

    if (!labels || labels.length === 0) {
        return <TableCell>-</TableCell>;
    }

    return (
        <TableCell sx={{ width: '20%' }}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {labels.slice(0, 2).map(label => (
                    <Box
                        key={label.id}
                        sx={{
                            backgroundColor: label.color,
                            color: getContrastColor(label.color),
                            px: 1,
                            py: 0.5,
                            borderRadius: '16px !important',
                            fontSize: '0.75rem',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {label.name}
                    </Box>
                ))}
                {labels.length > 2 && (
                    <Tooltip title={labels.slice(2).map(label => label.name).join(', ')} placement="top">
                        <Box
                            sx={{
                                color: theme.palette.primary.main,
                                px: 1,
                                py: 0.5,
                                borderRadius: '16px',
                                fontSize: '0.75rem',
                                whiteSpace: 'nowrap',
                                cursor: 'pointer', 
                            }}
                        >
                            +{labels.length - 2}
                        </Box>
                    </Tooltip>
                )}
            </Box>
        </TableCell>
    );
};
